<template>
<div class="chapter">
<div class="inner_page">
<div>
</div>
<div>
<h1 class="center">EDITOR’S NOTE</h1>
<p class="noind" style="margin-top:20px;">Few subjects are as rich, complex, and profound as exile. This is especially true if one allows its definition to venture beyond the political, religious, or cultural, so that it embraces the deeply personal, psychological, and emotional terrains in which individuals inhabit a place of self-exile, or even exile from sanity and surety.</p>
<p class="ind"> From Africa to China, Pakistan to the Philippines to locales that are not to be found on any map, this issue examines exile as both a literal expulsion or ostracism and, as Primo Levi has it, “the prevalence of the unreal over the real.” H. G. Carrillo’s “Splaining Yourself” explores, with an incandescent ferocity of bilingualism, the difficulties of living on the racial, ethnic, linguistic divide between two cultures, a member assimilated into and yet estranged from both. Aleš Šteger investigates the sensibility of exile in Berlin. Edie Meidav offers a boxer’s-eye view of postrevolutionary Cuba, whose system of privilege and constraint under Castro drives a gifted fighter from his homeland across the waters to Miami, where he is a man finally without a country. Robin Hemley’s “Celebrating Russian Federation Day with Immanuel Kant” delves into that singular world of exclaves, with its own highly individual problems about nationality and cultural identity.</p>
<p class="ind"> The permutations of our theme are extensive. Here is an agonizing story of love that impels a man far from the precincts of rational decision making, exiling him to a locus where all that remains is a guarantee of personal destruction. Here is an orphan who exiles himself from his home to live in makeshift proximity and spy on those who move in to take his place. Here is Charles Baudelaire’s proposal for a book excoriating Belgium, a country to which he has grudgingly fled after abandoning his native France—a vitriolic, painful, and hilarious document appearing for the first time in English in a superb translation by Richard Sieburth.</p>
<p class="ind"> We hope this issue provides some fresh insights into the exiles’ worlds, and makes a modest contribution to a literature that is ancient, essential, and multifarious.</p>
<p class="right">—Bradford Morrow</p>
<p class="right">April 2014</p>
<p class="right">New York City</p>
</div>
<div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ednote7.vue?41220891